// レコメンド商品一覧
// condProd: 条件の商品
// recommendProdHandle: 表示する商品、レコメンド商品
const recommendList = [
  {
    condProd: ["6576171417729"],
    recommendProdHandle: "0710000100",
  },
  {
    condProd: ["6576171810945"],
    recommendProdHandle: "0710000200",
  },
  {
    condProd: ["6576172007553"],
    recommendProdHandle: "0710000700",
  },
  {
    condProd: ["6576172040321"],
    recommendProdHandle: "0700013900",
  },
  {
    condProd: ["6576172073089"],
    recommendProdHandle: "0000330048",
  },
];

// ---------------- カート削除ボタン、個数変更ボタン無効 ----------------
const hideDeleteButton = () => {
  let deleteButtons = document.getElementsByClassName("mikawaya-hidden-delete");
  deleteButtons = [].slice.call(deleteButtons, 0);

  let quantityInputs = document.getElementsByClassName(
    "mikawaya-disable-quantity"
  );
  quantityInputs = [].slice.call(quantityInputs, 0);

  let hasZeroPrice = false;
  let hasPrice = false;

  cartItems.map((item) => {
    if (item.price > 0) {
      hasPrice = true;
    }
    if (item.price == 0) {
      hasZeroPrice = true;
    }
  });

  //Box状態チェック、親商品あり（値段あり）、子商品あり（値段＝０）
  if (hasPrice && hasZeroPrice) {
    deleteButtons.forEach((item) => {
      item.style.display = "none";
    });
    quantityInputs.forEach((item) => {
      item.setAttribute("disabled", "true");
    });
  }
};

//レコメンド商品取得
const getRecommendProduct = () => {
  let currentRecommend = "";
  label: for (let i = 0; i < cartItems.length; i++) {
    for (let j = 0; j < recommendList.length; j++) {
      const found = recommendList[j].condProd.find(
        (cond) => cond == cartItems[i].product_id.toString()
      );
      if (found) {
        currentRecommend = recommendList[j].recommendProdHandle;
        break label;
      }
    }
  }
  return currentRecommend;
};

const formatPrice = (amount) => {
  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
  }).format(amount);
};

window.onload = () => {
  hideDeleteButton();

  let currentRecommend = getRecommendProduct();
  console.log("currentRecommend => ",currentRecommend)

  if (currentRecommend != "") {
    let recommendProdInfo = fetch(
      "https://chocozap.shop/products/" + currentRecommend + ".js"
    )
      .then((response) => response.json())
      .then((data) => {
        const topRecommendElm = document.getElementById(
          "mikawaya-recommend-container-top"
        );

        const bottomRecommendElm = document.getElementById(
          "mikawaya-recommend-container-bottom"
        );

        const generateRecommendImage = (prodData) => {
          let imgContainer = document.createElement("div");
          imgContainer.classList = "mikawaya-image-container";

          let imgElm = document.createElement("img");
          imgElm.classList = "mikawaya-image-container";
          imgElm.style = "border: 1px solid #d8d8d8";
          imgElm.src = prodData.images[0];

          imgContainer.append(imgElm);

          return imgContainer;
        };

        const generateRecommendInfo = (prodData) => {
          let infoContainer = document.createElement("div");
          infoContainer.classList = "mikawaya-info-container";

          let titleContainer = document.createElement("div");
          titleContainer.style =
            "display: inline-flex; height: 50%; font-weight: bold;";
          let title = document.createElement("div");
          title.style = "text-align: left; padding-right: 20px;";
          title.innerHTML = prodData.title;
          let price = document.createElement("div");
          price.innerHTML = formatPrice(prodData.price / 100);
          titleContainer.append(title);
          titleContainer.append(price);

          let buttonContainer = document.createElement("div");
          buttonContainer.style =
            "height: 50%; display: flex; align-items: flex-end; float: right;";
          let button = document.createElement("button");
          button.type = "button";
          button.innerHTML = "カートに入れる";
          button.classList = "mikawaya-recommend-buy-button";
          button.addEventListener("click", function () {
            const baseURL = `https://${window.location.host}/cart/add?`;
            const itemURL = `id=${prodData.variants[0].id}&quantity=1`;
            window.location.assign(baseURL + itemURL);
          });
          buttonContainer.append(button);

          infoContainer.append(titleContainer);
          infoContainer.append(buttonContainer);

          return infoContainer;
        };

        //携帯版
        topRecommendElm.append(generateRecommendImage(data));
        topRecommendElm.append(generateRecommendInfo(data));

        //デスクトップ版
        bottomRecommendElm.append(generateRecommendImage(data));
        bottomRecommendElm.append(generateRecommendInfo(data));

        //メッセージ表示
        const message = "こちらの商品もご一緒にいかがでしょうか";
        const topMessageElm = document.getElementById(
          "mikawaya-recommend-message-top"
        );
        const bottomMessageElm = document.getElementById(
          "mikawaya-recommend-message-bottom"
        );
        topMessageElm.innerHTML = message;
        bottomMessageElm.innerHTML = message;
      });
  }
};
